import React from 'react';

export function MeasurementHistory({ measurements, samples }) {
  return (
    <section aria-label="Measurement history" className="space-y-3">
      <h2 className="text-xl font-semibold">Measurement history</h2>
      <p>Historical, unclassified, and other non-current Measurements are read-only. Missing cycle identities are never inferred.</p>
      <div className="overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead><tr>{['Filename', 'Pipeline', 'Cycle', 'Import status', 'Exclusion', 'Sample', 'Saved trace'].map((label) => <th key={label} className="p-2 text-left">{label}</th>)}</tr></thead>
          <tbody>{measurements.map((item) => (
            <tr key={item.id}>
              <td className="p-2">{item.filename}</td>
              <td>{item.pipeline || 'Unknown'}</td>
              <td>{item.cycle_number == null ? 'Historical / unclassified' : item.cycle_number}</td>
              <td>{item.status || 'Unknown'}{item.reason_message && <p>{item.reason_message}</p>}</td>
              <td>{item.is_excluded ? `Excluded${item.exclusion_reason ? `: ${item.exclusion_reason}` : ''}` : 'Not excluded'}</td>
              <td>{item.linked_sample_name || samples.find((sample) => String(sample.id) === String(item.sample_id))?.name || item.sample_id || 'Ungrouped'}</td>
              <td>{item.selected_trace_id || 'No saved selection'}{item.selected_wavelength_nm != null ? ` · ${item.selected_wavelength_nm} nm` : ''}</td>
            </tr>
          ))}</tbody>
        </table>
      </div>
      {!measurements.length && <p>No historical Measurements.</p>}
    </section>
  );
}
